(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reem-announcements"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.reem-announce').forEach((bar) => {
    const items = bar.querySelectorAll('.reem-announce__item');
    if (items.length < 2) return;
    let i = 0;
    const speed = (Number(bar.dataset.speed) || 4) * 1000;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, speed);
  });

  } catch(e) { console.error(e); }
})();
})();
